



















































import { Component, Prop, Vue, Emit } from "vue-property-decorator";

import SimpleMessageDialog from "@/components/common/SimpleMessageDialog.vue";
import { CapabilitiyStep } from "@/interfaces/devices/browser";

@Component({
  components: {
    SimpleMessageDialog
  }
})
export default class DeviceCapabilitiesDialog extends Vue {
  @Prop({ required: true })
  isDisplayDialog!: boolean;

  @Prop({ required: true, default: [] })
  steps!: CapabilitiyStep[];

  @Emit()
  hidePrompt() {
    return !this.isDisplayDialog;
  }

  @Emit()
  submit() {
    return !this.isDisplayDialog;
  }
}
